export const payment_status = [
    { value: 1, text: 'Unpaid' },
    { value: 2, text: 'For Validation' },
    { value: 3, text: 'Paid' },
    { value: 4, text: 'For Refund' },
    { value: 5, text: 'Refunded' },
]

export default payment_status;